import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AuthLayout from './layout/AuthLayout';
import MainLayout from './layout/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';

import Signup from './pages/user/auth/Signup';
import Login from './pages/user/auth/Login';
import ForgotPassword from './pages/user/auth/ForgotPassword';
import UpdatePassword from './pages/user/auth/UpdatePassword';
import AccountCreated from './pages/user/auth/AccountCreated';
import AccountDeleted from './pages/user/auth/AccountDeleted';

// import Welcome from './pages/Welcome';
import Create from './pages/content/Create';
import List from './pages/content/List';
import ViewProfiles from './pages/profiles/ViewProfiles';
import ViewWebsites from './pages/websites/ViewWebsites';
import Content from './pages/content/Content';
// import Analyze from './pages/tools/Analyze';
// import Translate from './pages/tools/Translate';
// import Respin from './pages/tools/Respin';
import Account from './pages/user/account/Account';
import Support from './pages/support/Support';
import NotFound from './pages/NotFound';
import Contact from './pages/support/Contact';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route element={<AuthLayout />}>
          <Route path="/signup" element={<Signup />} />
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/account-created" element={<AccountCreated />} />
          <Route path="/account-deleted" element={<AccountDeleted />} />
        </Route>

        {/* Protected */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          {/* <Route path="/welcome" element={<Welcome />} /> */}
          <Route path="/create" element={<Create />} />
          <Route path="/content" element={<List />} />
          <Route path="/content/:id" element={<Content />} />
          {/* <Route path="/analyze" element={<Analyze />} /> */}
          {/* <Route path="/translate" element={<Translate />} /> */}
          {/* <Route path="/respin" element={<Respin />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Support />} />
          <Route path="/profiles" element={<ViewProfiles />} />
          <Route path="/websites" element={<ViewWebsites />} />
          <Route path="/account" element={<Account />} />
          <Route path="*" element={<NotFound />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;
